import { render } from "./SelectorOption.vue?vue&type=template&id=3292fd32&scoped=true"
import script from "./SelectorOption.vue?vue&type=script&lang=js"
export * from "./SelectorOption.vue?vue&type=script&lang=js"

import "./SelectorOption.vue?vue&type=style&index=0&id=3292fd32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3292fd32"]])

export default __exports__